import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import {
  buildLoginUrl,
  captureCurrentReturnUrl,
} from '../utils/authRedirect';
import { emitAuthExpired, isAuthRedirectSuppressed } from './authSession';

const api = axios.create({
  baseURL: '/api/v2.0', 
  headers: {
    'Content-Type': 'application/json',
    'x-auth-service': 'Frontend',
    
  },
});

// Automatically add token to each request
api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    
  }
  return config;
});

// Auto-logout on 401
api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      if (isAuthRedirectSuppressed()) {
        emitAuthExpired();
      } else {
        const returnUrl = captureCurrentReturnUrl();
        localStorage.removeItem('token');
        localStorage.removeItem('userName');
        localStorage.removeItem('id');
        window.location.href = buildLoginUrl({
          timeout: true,
          returnUrl,
        });
      }
    }
    return Promise.reject(error);
  }
);

export default api;
